import React, { useEffect, useState } from "react";
import useSize from "../../../../Utils/useSize/useSize";
import NotFound from "../../../../Utils/NotFound/NotFound";

import Header from "./Header";
import BidAskTable from "./BidAskTable";
import DayRange from "./DayRange";
import Details from "./Details";

export default function MarketDepth() {
  const windowSize = useSize();

  const [symbol, setSymbol] = useState(null);

  useEffect(() => {
    const savedSymbol =
      window.symboldata ||
      JSON.parse(localStorage.getItem("symboldata") || "null");
    if (savedSymbol) {
      setSymbol(savedSymbol);
      localStorage.setItem("symboldata", JSON.stringify(savedSymbol));
    }
  }, []);

  if (!symbol)
    return (
      <div className="flex justify-center items-center text-gray-400">
        <NotFound
          small
          height={windowSize[1] - 100}
          title="Nothing here"
          subtext="Loading symbol..."
        />
      </div>
    );

  return (
    <div
      style={{
        height: windowSize[1] - 100,
      }}
      className="bg-[var(--background)] flex flex-col relative"
    >
      <div className=" rounded-lg bg-[var(--background)]">
        {/* Header */}
        <Header symbol={symbol} />

        <div
          style={{
            overflowY: "scroll",
            height: windowSize[1] - 70,
            paddingBottom: 200,
          }}
        >
          {/* Bid/Offer table */}
          <BidAskTable symbol={symbol} />

          {/* Day range */}
          <DayRange symbol={symbol} />

          {/* Details list */}
          <Details symbol={symbol} />
        </div>
      </div>
    </div>
  );
}
